import { sentenceCase } from "change-case-all";
import styled from "styled-components";
import { CgEye } from "react-icons/cg";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Chip, Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Search } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.publicisBlue};
  color: ${colors.publicisBlue};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 10px;
  &:hover {
    border: 1px solid ${colors.publicisBlue};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  campaigns,
  component,
  categorize,
  setPage,
  setSearchKey,
  loading,
}) {
  const navigate = useNavigate();
  let columns = [
    { name: "campaign_name", label: "Name" },
    {
      name: "camapign_period",
      label: "Period",
    },
    {
      name: "audience_size",
      label: "Audience Size",
    },
    {
      name: "audience_cpm",
      label: "CPM",
    },
    { name: "displayStatus", label: "Status" },
    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "audience_cpm") {
      return value ? value : "-";
    }

    if (col.name === "audience_size") {
      return value
        ? value
        : row.campaign_tentative_size
        ? `${row.campaign_tentative_size}(T)`
        : "-";
    }

    if (col.name === "camapign_period") {
      return (
        convertDate(row.start_duration) + " - " + convertDate(row.end_duration)
      );
    }

    if (col.name === "displayStatus") {
      let color;
      let backgroundColor;
      if (value === "CREATED" || value === "DRAFT") {
        backgroundColor = "#ECEFF1";
        color = "#37474F";
      }

      if (value === "Approval Requested") {
        backgroundColor = "#FFE0B2";
        color = "#E65100";
      }

      if (value === "Sizing in Progress") {
        backgroundColor = "#E3F2FD";
        color = "#1565C0";
      }

      if (value === "Size Ready") {
        backgroundColor = "#EDE7F6";
        color = "#512DA8";
      }

      if (value === "Go-Live Requested") {
        backgroundColor = "#FFF8E1";
        color = "#F9A825";
      }

      if (value === "ACTIVE") {
        backgroundColor = "#E8F5E9";
        color = "#2E7D32";
      }

      if (value === "Expired") {
        backgroundColor = "#FFEBEE";
        color = "#C62828";
      }

      if (value === "REJECTED") {
        backgroundColor = "#FFEBEE";
        color = "#C62828";
      }

      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: backgroundColor,
            color: color,
          }}
          label={sentenceCase(value?.replace(/_/g, " "))}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Campaign">
            <Icon>
              <CgEye
                onClick={() => handleRedirection(row, "view")}
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>

          {component === "" &&
            row.status !== "REQUESTED" &&
            row.status !== "ACTIVE" &&
            row.status !== "INITIATED" &&
            row.isEditable && (
              <Tooltip title="Edit Campaign">
                <Icon onClick={() => handleRedirection(row, "edit")}>
                  <MdEdit style={{ height: "20px", width: "20px" }} />
                </Icon>
              </Tooltip>
            )}
        </div>
      );
    }

    return value; // default
  };

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar setPage={setPage} setSearchKey={setSearchKey} />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={campaigns}
        />
      </Grid>
    </Grid>
  );

  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }

  function handleRedirection(campaign, mode) {
    if (component === "request") {
      navigate(
        pages.campaignRequestDetails.route +
          campaign.sender_campaignId +
          "?brandID=" +
          campaign.sender_brandId +
          "&mode=" +
          mode
      );
    }

    if (component === "superadmin") {
      navigate(
        pages.superAdminCampaignDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode,
        { state: { categorize: categorize } }
      );
    }

    if (component === "accepted") {
      navigate(
        pages.campaignAcceptedDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode
      );
    }

    if (component === "") {
      navigate(
        pages.campaignDetails.route + campaign.campaign_id + "?mode=" + mode
      );
    }
  }
}

export function ToolBar({ setPage, setSearchKey }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "end",
      }}
    >
      <div>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
      </div>

      {/* <div style={{ margin: "auto 0px" }}>
        <Tooltip title="Download Report">
          <Icon loading={loading} onClick={handleDownloadReport}>
            <FaFileDownload />
          </Icon>
        </Tooltip>
      </div> */}
    </div>
  );
}
